import { render, staticRenderFns } from "./VueTypedJs.vue?vue&type=template&id=13df97e9"
import script from "./VueTypedJs.vue?vue&type=script&lang=js"
export * from "./VueTypedJs.vue?vue&type=script&lang=js"
import style0 from "./VueTypedJs.vue?vue&type=style&index=0&id=13df97e9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports